export default "__VITE_ASSET__CjTR5yI3__"